// extracted by mini-css-extract-plugin
export var colorBar = "ColorBar-module--colorBar--28746";